import React from "react";
import { Headphones, Users, Monitor, ScrollText, BookOpen } from "lucide-react";
import { EditableText } from "./live/Editable";

const items = [
  { icon: Headphones, label: "Online support 24/7", key: "support" },
  { icon: Users, label: "Experienced instructors", key: "instructors" },
  { icon: Monitor, label: "Easy to use interface", key: "interface" },
  { icon: ScrollText, label: "Valid digital certificates", key: "certificates" },
  { icon: BookOpen, label: "Free online library", key: "library" },
];

export default function FeaturesStrip() {
  return (
    <section className="relative -mt-16 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-6 md:p-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {items.map(({ icon: Icon, label, key }, i) => (
            <div
              key={key}
              className="flex flex-col items-center text-center group animate-fade-up"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="h-14 w-14 rounded-2xl bg-yellow-400/15 flex items-center justify-center group-hover:bg-yellow-400 group-hover:scale-110 transition">
                <Icon className="h-7 w-7 text-yellow-600 group-hover:text-[#0B2A6B] transition" />
              </div>
              <EditableText
                path={`home.features.${key}`}
                as="p"
                className="mt-3 text-sm font-semibold text-slate-700"
              >
                {label}
              </EditableText>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
